module.exports = __webpack_public_path__ + "img/logo-bank-sumselbabel-syariah-color.cec3098e.png";